import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import { fetchPurchaseOrderProductByID } from '../../actions/purchaseOrders_actions';
import { fetchPurchaseOrderSuggestions } from '../../actions/autoSuggest_actions';
import { isGGI, isOLG, isGFD } from '../../actions/root_url';

/* ----------- */
/*    Utils    */
/* ----------- */

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/* --------------- */
/*    Component    */
/* --------------- */

class PurchaseOrderAutoSuggest extends Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: [],
      // isLoading: false,
      noSuggestions: false,
    };

    this.lastRequestId = null;
  }

  componentWillReceiveProps(nextProps) {
    const isInputBlank = nextProps.value === '';
    const noSuggestions = !isInputBlank && nextProps.purchaseOrderSuggestions.length === 0;
    this.setState({ noSuggestions });
    if (nextProps.purchaseOrderSuggestions !== this.props.purchaseOrderSuggestions) {
      this.setState({ suggestions: [...(nextProps.purchaseOrderSuggestions).slice(0, 200)] });
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({ value: newValue });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.loadSuggestions(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  onFocus(event) {
    event.target.select();
  }

  onKeyPress = () => false;

  onSuggestionSelected = (event, { suggestion }) => {
    // function to get product here
    event.stopPropagation();
    event.preventDefault();
    if(isGGI || isGFD) {
      this.props.handleSetSlect(suggestion)
    }
    this.props.fetchPurchaseOrderProductByID(suggestion.Product_id);
    this.props.handleFocusQty();
  }

  getSuggestionValue = (suggestion) => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;

      default:
        return null;
    }
  }

  loadSuggestions(value) {
    // if (value.length < 3) {
    //   return;
    // }
    // Cancel the previous request
    // if (this.lastRequestId !== null) {
    //   clearTimeout(this.lastRequestId);
    // }

    // this.setState({
    //   isLoading: true,
    //   suggest: [],
    // });
    const warehouse_id = this.props.warehouse.value || this.props.warehouse;
    this.props.fetchPurchaseOrderSuggestions(this.props.SearchType, value, warehouse_id, this.props.isFLTPO);

    // Fake request
    // this.lastRequestId = setTimeout(() => {
    //   axios.get(`${ROOT_URL}v1/product/simplified/?${this.props.SearchType}=${value}`,
    //   {
    //       headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    //   })
    //   .then(response => {
    //     const suggestionData = [...response.data];
    //     this.setState({
    //       isLoading: false,
    //       suggestions: suggestionData,
    //     });
    //   }, err => {
    //     console.log('error occured in search', err);
    //   });
    // }, 100);
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.purchaseOrderSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  renderSearchTypeValue(suggestion) {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return suggestion.ProductNum;
      default:
        return suggestion.RefNum;
    }
  }

  renderSuggestion = (suggestion) =>
    <Row className="suggestion" id="suggestion-render" className='sales-auto-suggest-suggestions'>
      <Col xs={isOLG ? 1 : 2}>
        {this.renderSearchTypeValue(suggestion)}
      </Col>
      {!isOLG && <Col xs={4}>
        {suggestion.Name}
      </Col>}
      <Col xs={1}>
        {suggestion.Description}
      </Col>
      <Col xs={1} id="price-col">
        {suggestion.ProductCost}
      </Col>
      <Col xs={1} style={{ overflow: 'hidden' }}>
        {suggestion.MeasureUnit}
      </Col>
      <Col xs={1}>
        {suggestion.InStock}
      </Col>
      <Col xs={1}>
        {suggestion.Purchased}
      </Col>
      <Col xs={1}>
        {suggestion.PreSale}
      </Col>
    </Row>

  renderSearchTypeHeader = () => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return <Translate value="prod_num" />;
      default:
        return <Translate value={isOLG ? "item_no" : "ref_num"} />;
    }
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };

    return (
      <div {...restContainerProps}>
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={isOLG ? 1: 2}>
              {this.renderSearchTypeHeader()}
            </Col>
            {!isOLG && <Col xs={4}>
              <Translate value="prod_name" />
            </Col>}
            <Col xs={1}>
              <Translate value="desc" />
            </Col>
            <Col xs={1} id="price-col">
              <Translate value="unit_dollarsign" />
            </Col>
            <Col xs={1} style={{ overflow: 'hidden' }}>
              <Translate value="pkg_type" />
            </Col>
            <Col xs={1}>
              <Translate value="instock" />
            </Col>
            <Col xs={1}>
              <Translate value="purchased" />
            </Col>
            <Col xs={1}>
              <Translate value="presale" />
            </Col>
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'purchase-auto-suggest',
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          onSuggestionSelected={this.onSuggestionSelected}
          highlightFirstSuggestion
          inputProps={inputProps}
        />
        {this.renderErrorMessage()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    purchaseOrderSuggestions: state.autoSuggest.purchaseOrderSuggestions,
    purchaseOrderSuggestionsIsLoading: state.autoSuggest.purchaseOrderSuggestionsIsLoading,
    purchaseOrderSuggestionsError: state.autoSuggest.purchaseOrderSuggestionsError,
  };
}

export default connect(mapStateToProps, { fetchPurchaseOrderProductByID, fetchPurchaseOrderSuggestions })(PurchaseOrderAutoSuggest);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/PurchaseOrderAutoSuggest.jsx